import { useEffect, useState } from "react";
import { apiCallSPPost, apiExportToExcel } from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import SearchFilter from "../Component/searchFilter";
import { SearchFilterModel } from "../Component/SearchFilterModel";
import { updateSearchStatus } from "src/views/common/CommonSearch";
import CommonList from "src/views/common/CommonList";

const PBSMSTransferedLotListReport = () => {
  const { authenticated } = Auth();
  const [usersData, setUsersData] = useState(); // List Data Set
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  const [isExporting, setIsExporting] = useState(false); //Export To Excel Loader Manage

  const [search, setSearch] = useState(SearchFilterModel); // Search Model

  // Page  API URL manage
  const ReportListUrl = `Report/PBSMS/Transfered_Lot`;
  const ReportListCountUrl = `Report/PBSMS/Transfered_Lot/count`;
  const ReportListExcelUrl = `Report/PBSMS/Transfered_Lot/ExportToExcel`;
  const ReportListExcelFileName = "PBSMSTransferedLotListReport.xls";

  useEffect(() => {
    setloading(true);
    reset();
    getReportCount(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {

      getReportList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit]);
  useEffect(() => {
    if (isSearch) {
      getReportList();
      getReportCount();
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Disabled Manage
  const paggingManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  // api data manage
  const getdata = (setPageLimits = "", setItemPerPages = "") => {
  
    return JSON.stringify({
      start: setPageLimits === "" ? pageLimit : setPageLimits,
      length: setItemPerPages === "" ? itemPerPage : setItemPerPages,
      collection_season: Number(search.collectionSeason),
      tenderNo: search.tenderNo.trim(),
      circle_id: Number(search.circleId),
      district_id: Number(search.disctrictId),
      lot_no: search.lotNo.trim(),
      //date: search.date,
    });
  };

  // get Report List
  const getReportList = async () => {
    if (authenticated) {
      setloading(true);
      paggingDisabled();
      setUsersData();

      await apiCallSPPost(ReportListUrl, getdata(), [])
        .then((res) => {
          if (res.success) {
            setUsersData(res.data);
            if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
              paggingManage(pageCount);
            }
          } else setUsersData();
        })
        .finally(() => {
          setloading(false);
        });
    }
  };

  // get Report List Count
  const getReportCount = async () => {
    if (authenticated) {
      await apiCallSPPost(ReportListCountUrl, getdata(0, 0), 0).then((res) => {
        if (res.success) paggingManage(parseInt(res.totalRecord) || 0);
      });
    }
  };
  // get Report List ExportToExcel
  const ExportToExcel = async () => {
    
    setIsExporting(true);
    try {
      await apiExportToExcel(
        pageCount,
        ReportListExcelUrl,
        getdata(0, 0),
        ReportListExcelFileName
      ).finally(() => {
        setIsExporting(false);
      });
    } catch (error) {
      // Handle any errors that might occur during the export process
      console.error("Error exporting to Excel:", error);
      setIsExporting(false); // Reset isExporting state if an error occurs
    }
  };

  const reset = () => {
    setpageLimit(0);
  };

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitCheck = pageLimit - parseInt(itemPerPage);
    if (pageLimitCheck < 0) {
      pageLimitCheck = 0;
    }
    setpageLimit(pageLimitCheck);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitCheck = pageLimit + parseInt(itemPerPage);
    if (pageLimitCheck >= parseInt(pageCount)) {
      pageLimitCheck = parseInt(pageCount);
      setdisablednext(true);
    }
    setpageLimit(pageLimitCheck);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsSearch(true);
  };

  //Clear Button Click Event
  const clearSearch = (ev) => {
    ev.preventDefault();
    reset();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setUsersData();
  };

  //Search Filter Manage ( UI also)
  let additional = (
    <SearchFilter
      isDisabledSearchClear={loading}
      isClear={isClear}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearch={clearSearch}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      isExporting={isExporting}
      isDisabledExport={usersData && usersData.length > 0 ? false : true}
      ExportToExcel={ExportToExcel}
    />
  );

  // List Header And data bind
  const fields = [
    {
      key: "srNo",
      _style: { width: "5%" },
      label: "S.N.",
    },
    {
      key: "circleName",
      _style: { width: "7.5%" },
      label: "Circle",
    },
    {
      key: "districtName",
      _style: { width: "7.5%" },
      label: "District Union",
    },
    {
      key: "lotNo",
      _style: { width: "5%" },
      label: "Lot No.",
    },

    {
      key: "actualQuantity",
      _style: { width: "5%" },
      label: "Actual Quantity (Per STD Bags)",
    },
    {
      key: "saleRate",
      _style: { width: "5%" },
      label: "Sale Rate",
    },
    {
      key: "saleValue",
      _style: { width: "5%" },
      label: "Sale Value",
    },

    {
      key: "transferorName",
      _style: { width: "15%" },
      label: "Transderor (1st Party)",
    },
    {
      key: "transfereeName",
      _style: { width: "15%" },
      label: "Transferee (2nd Party)",
    },
    {
      key: "transferFeeReceived",
      _style: { width: "10%" },
      label: "Transfer Fee Received",
    },

{
      key: "emdAmount",
      _style: { width: "10%" },
      label: "SD 10% Received By Transferor",
    },
    {
      key: "sdReceivedByTransferorInBG",
      _style: { width: "10%" },
      label: "SD BG 15% Received By Transferor",
    },
    {
      key: "sdReceivedByTransferorOnline",
      _style: { width: "10%" },
      label: "SD Online 15% Received By Transferor",
    },
    {
      key: "totalSDReceivedByTransferer",
      _style: { width: "10%" },
      label: "Total SD Received By Transferor",
    },
    {
      key: "sdRefundedToTransferor",
      _style: { width: "10%" },
      label: "SD Refunded To Transferor",
    },
    {
      key: "sdRecievedByTransfereeInBG",
      _style: { width: "10%" },
      label: "SD BG Received By Transferee",
    },
    {
      key: "sdReceivedByTransferee",
      _style: { width: "10%" },
      label: "SD Online Received By Transferee",
    },
    {
      key: "totalSDReceivedByTransferee",
      _style: { width: "10%" },
      label: "Total SD Received By Transferor",
    },
    
  ];
  return (
    <CommonList
      items={usersData}
      fields={fields}
      listName="Transfered Lot List Report"
      loading={loading}
      additional={additional}
      prev={prevButton}
      next={nextButton}
      disabledprev={disabledprev}
      disablednext={disablednext}
      id="userid"
    />
  );
};

export default PBSMSTransferedLotListReport;
